/** Semantic tones a {@link Badge} can carry. */
export type BadgeTone = 'neutral' | 'accent' | 'danger' | 'success' | 'warning' | 'live';

/** Props for {@link Badge}. */
export interface BadgeProps {
  readonly children: React.ReactNode;
  /** Meaning conveyed by the badge. Defaults to `neutral`. */
  readonly tone?: BadgeTone;
}

/**
 * A small status label.
 *
 * The tone is always accompanied by its own text. Colour alone never carries the meaning, which
 * matters both for colour-blind users and for a screen in direct sunlight.
 *
 * @param props - Component props.
 * @returns The badge element.
 */
export function Badge({ children, tone = 'neutral' }: BadgeProps): React.JSX.Element {
  return <span className={`gm-badge gm-badge--${tone}`}>{children}</span>;
}
